import { apiClient } from './client';
import type { ApiSuccess, PaginationMeta } from '../types';

export interface AmElectricity {
  id: number;
  stationId: number;
  stationName: string | null;
  city: string | null;
  clientId: number | null;
  clientName: string | null;
  consumerNumber: string | null;
  discomName: string | null;
  monthYear: string;
  unitsConsumed: number | null;
  billAmount: number;
  dueDate: string;
  paidDate: string | null;
  paymentMode: string | null;
  transactionRef: string | null;
  lateFee: number;
  status: 'pending' | 'paid' | 'overdue';
  billDocumentUrl: string | null;
  billDate: string | null;
  consumerName: string | null;
  billNumber: string | null;
  fetchSource: string | null;
  createdAt: string;
}

export interface FetchedBill {
  discom: string | null; consumerNumber: string; consumerName: string | null; billNumber: string | null;
  billMonth: string; billDate: string | null; dueDate: string | null; units: number | null; amount: number; billPdfUrl: string | null; provider: string;
}
export interface FetchBillResult {
  configured: boolean; provider: string; message?: string; bill?: FetchedBill; saved?: boolean; alreadyExists?: boolean; record?: AmElectricity;
}

export interface ExtractedBill {
  configured: boolean;
  consumerNumber?: string | null;
  consumerName?: string | null;
  discomName?: string | null;
  billNumber?: string | null;
  billMonth?: string | null;   // YYYY-MM
  billDate?: string | null;    // YYYY-MM-DD
  dueDate?: string | null;     // YYYY-MM-DD
  unitsConsumed?: number | null;
  billAmount?: number | null;
  message?: string;
}

export interface CreateElectricityInput {
  stationId: number;
  clientId?: number | null;
  consumerNumber?: string;
  discomName?: string;
  monthYear: string;
  unitsConsumed?: number;
  billAmount: number;
  dueDate: string;
  billDocumentUrl?: string;
  consumerName?: string;
  billNumber?: string;
  billDate?: string;
}

export interface PayElectricityInput {
  paymentMode: 'NEFT' | 'RTGS' | 'UPI' | 'Cheque' | 'Cash';
  transactionRef?: string;
  paidDate?: string;
  lateFee?: number;
}

export const amElectricityApi = {
  async list(params: Record<string, unknown> = {}): Promise<{ data: AmElectricity[]; meta: PaginationMeta }> {
    const { data } = await apiClient.get<ApiSuccess<AmElectricity[]>>('/am-electricity', { params });
    return { data: data.data, meta: data.meta as PaginationMeta };
  },
  create: async (body: CreateElectricityInput) => (await apiClient.post<ApiSuccess<AmElectricity>>('/am-electricity', body)).data.data,
  fetch: async (body: { consumerNumber?: string; stationId?: number; discomName?: string; save?: boolean }) =>
    (await apiClient.post<ApiSuccess<FetchBillResult>>('/am-electricity/fetch', body)).data.data,
  extract: async (billDocumentUrl: string) =>
    (await apiClient.post<ApiSuccess<ExtractedBill>>('/am-electricity/extract', { billDocumentUrl })).data.data,
  update: async (id: number, body: Partial<CreateElectricityInput>) => (await apiClient.put<ApiSuccess<AmElectricity>>(`/am-electricity/${id}`, body)).data.data,
  pay: async (id: number, body: PayElectricityInput) => (await apiClient.post<ApiSuccess<AmElectricity>>(`/am-electricity/${id}/pay`, body)).data.data,
  remove: async (id: number) => { await apiClient.delete(`/am-electricity/${id}`); },
};
